module.exports = __webpack_public_path__ + "static/img/Robbie_Gray_desktop.75ecfdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Robbie_Gray_desktop.jpg
// module id = rR+n
// module chunks = 0